import { render, staticRenderFns } from "./goods-vip-all-protocol.old.vue?vue&type=template&id=0c487887&scoped=true"
import script from "./goods-vip-all-protocol.old.vue?vue&type=script&lang=js"
export * from "./goods-vip-all-protocol.old.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-all-protocol.old.vue?vue&type=style&index=0&id=0c487887&prod&lang=scss"
import style1 from "./goods-vip-all-protocol.old.vue?vue&type=style&index=1&id=0c487887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c487887",
  null
  
)

export default component.exports